import { render, staticRenderFns } from "./basket.vue?vue&type=template&id=db5f1b20&scoped=true"
import script from "./basket.vue?vue&type=script&lang=ts"
export * from "./basket.vue?vue&type=script&lang=ts"
import style0 from "./basket.vue?vue&type=style&index=0&id=db5f1b20&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5f1b20",
  null
  
)

export default component.exports